import { normaliseText } from '@1trading/ts-common/utils';
import { z } from 'zod';

/** An answer that may be left out: missing, blank or made only of invisible characters, it parses to `undefined` */
export const blankAsAbsent = <Output>(schema: z.ZodType<Output, string>) =>
  z
    .string()
    .optional()
    .transform((value) => (value === undefined || normaliseText(value) === '' ? undefined : value))
    .pipe(schema.optional());
